/*globals HJ_REVISION:true */
const { getEnvironmentId } = require('./utils/getEnvironmentId');
const dsn = 'https://75786e51fd834ac5a70737db81a4b9d8@sentry.io/1803156';

var Integrations = require('@sentry/integrations');

// Array of regular expressions or strings to ignore from sentry errors
const IGNORE_VALUES = [/\$digest already in progress/, /Non-Error exception captured/];

window.Sentry = require('@sentry/browser');
window.Sentry.init({
    dsn: dsn,
    environment: getEnvironmentId(),
    allowUrls: [
        /insights\.hotjar\.com/,
        /surveys\.hotjar\.com/,
        /insights-staging\.hotjar\.com/,
        /surveys-staging\.hotjar\.com/
    ],
    integrations: [new Integrations.Angular()],
    release: 'insights-frontend-' + HJ_REVISION,
    sampleRate: 1,
    /**
     * Array of regular expressions or strings to ignore
     * See docs: https://docs.sentry.io/clients/javascript/config/#optional-settings
     */
    ignoreErrors: IGNORE_VALUES,
    /**
     * A callback invoked during event submission, allowing to optionally modify the event before it is sent to Sentry.
     * @param Event The error or message event generated by the SDK.
     * @param EventHint May contain additional information about the original exception.
     * @returns PromiseLike<Event | null> | Event | null
     */
    beforeSend: function (event, hint) {
        // exception: Error | string | null
        const exception = hint?.originalException;

        // Add custom fingerprint to exceptions that have the substring 'queryselectorAll' in the message
        // so that they are all grouped together in Sentry
        if ([exception, exception?.message].includes("Failed to execute 'querySelectorAll' on 'Document'")) {
            event.fingerprint = ['querySelectorAll-error'];
        }

        return event;
    }
});
